module.exports = __webpack_public_path__ + "assets/camera-black_icon.a7aad174.svg";